"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-checklist", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M14.04 17L22 9.144 20.84 8l-6.8 6.703-1.88-1.847L11 14z", fillRule: "nonzero" }),
            _react2.default.createElement("path", { d: "M21 14v4.007A3.001 3.001 0 0 1 18.007 21H9.993A3.001 3.001 0 0 1 7 18.007V9.993A3.001 3.001 0 0 1 9.993 7H18v1H9.993A2.001 2.001 0 0 0 8 9.993v8.014C8 19.1 8.897 20 9.993 20h8.014A2.001 2.001 0 0 0 20 18.007V14h1z", fill: "#4C4C4C", fillRule: "nonzero" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-checklist.js
// module id = 1880
// module chunks = 0